// extracted by mini-css-extract-plugin
export var label = "_dm-5";
export var slideContainer = "_dm-0";
export var slider = "_dm-1";
export var sliderLg = "_dm-4";
export var sliderMd = "_dm-3";
export var sliderSm = "_dm-2";